/* ===========================================================
   LURU CHOCOLATE CO. — CUSTOM THEME JAVASCRIPT
   This is the ONLY custom JS file. Loaded before </body>.
=========================================================== */

(function () {
  'use strict';

  /* -----------------------------------------------------------
     Utility: debounce
  ----------------------------------------------------------- */
  function debounce(fn, wait) {
    var timeout;

    return function () {
      var context = this;
      var args = arguments;

      clearTimeout(timeout);

      timeout = setTimeout(function () {
        fn.apply(context, args);
      }, wait);
    };
  }

  /* -----------------------------------------------------------
     Utility: throttle (rAF-based, for scroll handlers)
  ----------------------------------------------------------- */
  function rafThrottle(fn) {
    var queued = false;

    return function () {
      var context = this;
      var args = arguments;

      if (!queued) {
        queued = true;

        window.requestAnimationFrame(function () {
          fn.apply(context, args);
          queued = false;
        });
      }
    };
  }

  /* -----------------------------------------------------------
     Luxury Collection Grid — simple fade-in on scroll
  ----------------------------------------------------------- */
  function initGridReveal() {
    var items = document.querySelectorAll('.luru-grid__item');

    if (!items.length || !('IntersectionObserver' in window)) {
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.15
    });

    items.forEach(function (item) {
      observer.observe(item);
    });
  }

  /* -----------------------------------------------------------
     Reviews — desktop carousel controls
     Mobile uses native horizontal swipe
  ----------------------------------------------------------- */
  function initReviewsCarousel() {
    var sections = document.querySelectorAll('[data-luru-reviews]');

    sections.forEach(function (section) {
      var track = section.querySelector('.luru-reviews__track');
      var prevBtn = section.querySelector('[data-reviews-prev]');
      var nextBtn = section.querySelector('[data-reviews-next]');

      if (!track) {
        return;
      }

      function scrollByCard(direction) {
        var card = track.querySelector('.luru-reviews__card');

        if (!card) {
          return;
        }

        var cardWidth = card.getBoundingClientRect().width;

        var gap = parseFloat(
          getComputedStyle(track).gap || 16
        );

        if (isNaN(gap)) {
          gap = 16;
        }

        track.scrollBy({
          left: direction * (cardWidth + gap),
          behavior: 'smooth'
        });
      }

      if (prevBtn) {
        prevBtn.addEventListener('click', function () {
          scrollByCard(-1);
        });
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', function () {
          scrollByCard(1);
        });
      }
    });
  }

  /* -----------------------------------------------------------
     Header — Hide on scroll
  ----------------------------------------------------------- */
  function initHideOnScroll(selector) {
    var header = document.querySelector(selector);

    /* Stop if header doesn't exist */
    if (!header) {
      return;
    }

    var lastScrollY =
      window.pageYOffset || document.documentElement.scrollTop;

    var ticking = false;

    header.classList.add('luru-header-scroll');

    function updateHeader() {
      var currentScrollY =
        window.pageYOffset || document.documentElement.scrollTop;

      /* Always show header near the top */
      if (currentScrollY <= 20) {
        header.classList.remove('luru-header-hidden');
        lastScrollY = currentScrollY;
        ticking = false;
        return;
      }

      /* Scrolling down → hide */
      if (currentScrollY > lastScrollY + 5) {
        header.classList.add('luru-header-hidden');
      }

      /* Scrolling up → show */
      else if (currentScrollY < lastScrollY - 5) {
        header.classList.remove('luru-header-hidden');
      }

      lastScrollY = currentScrollY;
      ticking = false;
    }

    window.addEventListener('scroll', function () {
      if (!ticking) {
        window.requestAnimationFrame(updateHeader);
        ticking = true;
      }
    }, {
      passive: true
    });
  }

  /* -----------------------------------------------------------
     Init on DOM ready
  ----------------------------------------------------------- */
  function init() {
    initGridReveal();
    initReviewsCarousel();
    initHideOnScroll('.site-header');

    console.log('Luru custom JavaScript initialized');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* -----------------------------------------------------------
     Expose utilities globally
  ----------------------------------------------------------- */
  window.Luru = window.Luru || {};

  window.Luru.debounce = debounce;
  window.Luru.rafThrottle = rafThrottle;

})();